// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4YGKY","content":"styles_content__3_3Qe","row":"styles_row__42-_0","footer":"styles_footer__SvKzF","phraseLength":"styles_phraseLength__3jl2Q"};